import React, { useState, useEffect } from "react";
import { Grid, Button, Typography, IconButton } from "@mui/material";
import DetailRow from "@/pages/attendance/component/DetailRow";
import DisplayDates from "@/pages/attendance/component/DisplayDates";
import RegularizationAccordion from "@/pages/attendance/component/Accordion";
import renderActions from "@/pages/attendance/component/RenderActions";
import ViewRegularizationList from "@/pages/attendance/views/regularization/ViewRegularizationList/ViewRegularizationList";
import { Link } from "react-router-dom";
import { ArrowBackIosNewOutlinedIcon } from "@/icons";
import { CustomAlert } from "@/components";
import { useWithdrawRegularizationMutation } from "@/api/services/attendance/regularization/EmployeeRegularization";
import { toast } from "@/components/toastify";
import { format } from "date-fns";
import Loader from "@/components/loader";

const PendingRegularize = ({
  regularizationRecords,
  refetch,
  tabName,
  refetchHistory,
  isLoadingPending,
}) => {
  const [showViewList, setShowViewList] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);
  const [triggerGetData] = useWithdrawRegularizationMutation();
  const regRecords = regularizationRecords || [];
  const [openWithdrawPopUp, setOpenWithdrawPopUp] = useState(false);
  const withdrawClose = () => setOpenWithdrawPopUp(false);
  const [statusLoading, setStatusLoading] = useState(false);

  const [selectedRecord, setSelectedRecord] = useState(null);

  const getStatusLabel = (status) => {
    switch (status) {
      case "REG":
        return "Regularization";
      case "WFH":
        return "Work From Home";
      case "OD":
        return "On Duty";
      default:
        return "";
    }
  };

  const renderDetails = (item) => {
    console.log(item, "itemmm");
    const workTypes = item.appliedRegularizations
      ?.map((reg) => getStatusLabel(reg.regularizationStatus))
      .join(", ");
    // const reasons  = item.reason
    // ?.map((reg) => getStatusLabel(reg.regularizationStatus))
    // .join(", ");
    const reasons = item.appliedRegularizations
      ?.map((reg) => reg.reason)
      .join(", ");

    return (
      <Grid container spacing={2}>
        <DetailRow label="Work Type" value={workTypes} />
        <DetailRow label="Pending For" value={item.approverName} />
        <DetailRow label="No. of days" value={item.noOfDays} />
        <DetailRow
          label="Applied For"
          value={<DisplayDates dates={item.regularizationDates} />}
        />
        <DetailRow label="Reason(s)" value={reasons} />
      </Grid>
    );
  };

  const handleWithdrawClick = (item) => {
    const rawDate = item.regularizationDates?.[0];
    const formattedYearMonth = rawDate
      ? format(new Date(rawDate), "MM-yyyy")
      : "";
    setSelectedItem({
      employeeId: item.empId,
      regularizationCode: item.regularizationCode,
      yearMonth: formattedYearMonth,
    });
    setOpenWithdrawPopUp(true);
  };

  const handleWithdrawPopUpSubmit = async () => {
    if (!selectedItem) return;
    setStatusLoading(true);
    try {
      await triggerGetData({
        empId: selectedItem?.employeeId,
        regCode: selectedItem?.regularizationCode,
        yearMonth: selectedItem?.yearMonth,
      }).unwrap();
      toast("success", "Regularization Withdraw");
      await refetch();
      await refetchHistory();
      setOpenWithdrawPopUp(false);
      setSelectedItem(null);
      setShowViewList(false);
      setStatusLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setStatusLoading(false);
    }
    setOpenWithdrawPopUp(false);
    setSelectedItem(null);
    setShowViewList(false);
  };

  const actions = (item) => [
    {
      variant: "outlined",
      color: "warning",
      background: "Warning",
      shade: "100",
      label: "Withdraw",
      hover: true,
      sx: {
        /* additional styles */
        backgroundColor: (theme) => theme.palette.BudgieThemeColor.Warning[100],
        color: (theme) => theme.palette.BudgieThemeColor.Warning[600],
        borderColor: "warning.main",
        p: (theme) => theme.spacing(1, 2),
        m: (theme) => theme.spacing(0, 1),
        borderRadius: (theme) => theme.shape.s,
      },
      hoverSx: {
        /* additional styles */
        backgroundColor: "warning.main",
        color: "warning.contrastText",
        borderColor: "warning.main",
      },
      onclick: () => {
        handleWithdrawClick(item);
      },
    },
    {
      label: "View",
      variant: "outlined",
      sx: {
        /* additional styles */
        backgroundColor: (theme) =>
          theme.palette.BudgieThemeColor.Primary[1200],
        color: (theme) => theme.palette.BudgieThemeColor.BaseWhite,
        p: (theme) => theme.spacing(1, 2),
        m: (theme) => theme.spacing(0, 1),
        borderRadius: (theme) => theme.shape.s,
      },
      hoverSx: {
        /* additional styles */
        backgroundColor: (theme) =>
          theme.palette.BudgieThemeColor.Primary[1200],
        color: (theme) => theme.palette.BudgieThemeColor.BaseWhite,
        borderColor: (theme) => theme.palette.BudgieThemeColor.Primary[600],
      },
      onclick: () => {
        setShowViewList(true);
        setSelectedRecord(item);
      },
    },
  ];

  const formatDate = (dateString) => {
    return new Date(dateString)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .split("/")
      .join("/");
  };

  return (
    <>
      {isLoadingPending ? (
        <Loader />
      ) : (
        <>
          {showViewList ? (
            <>
              <Typography variant="h4">
                <IconButton
                  component={Link}
                  to="/attendance/regularization"
                  color="primary"
                  onClick={() => setShowViewList(false)}
                >
                  <ArrowBackIosNewOutlinedIcon />
                </IconButton>
                Review Regularizations
              </Typography>
              <ViewRegularizationList
                selectedRecord={selectedRecord}
                setSelectedRecord={setSelectedRecord}
                setShowViewList={setShowViewList}
                tabName={tabName}
                refetch={refetch}
                refetchHistory={refetchHistory}
              />
            </>
          ) : (
            <RegularizationAccordion
              items={regRecords}
              renderDetails={renderDetails}
              renderActions={(item) => renderActions(item, actions(item))}
              containerSpacing={(theme) => theme.spacing(2)}
              detailsGridProps={{ xs: 12, sm: 9 }}
              actionsGridProps={{ xs: 12, sm: 3 }}
              accordionProps={{ elevation: 1 }}
              getTitle={(item) =>
                `Applied on : ${formatDate(item.appliedDate)}`
              }
              showActions={true}
            />
          )}
          <CustomAlert
            open={openWithdrawPopUp}
            title="Withdraw Request"
            message="Are you sure you want to withdraw this application?"
            onCancel={withdrawClose}
            onSubmit={handleWithdrawPopUpSubmit}
            cancelText="Cancel"
            submitText="Submit"
            isSubmitting={statusLoading}
          />
        </>
      )}
    </>
  );
};

export default PendingRegularize;
